import { isEmpty } from 'lodash';
import { IFGAGroupMapping, IReBACGroupMappings } from 'types/api';

export const parseSSOReBACGroupsMappings = (
	rebacGroupsMappings: Record<string, IReBACGroupMappings> | undefined
) => {
	if (isEmpty(rebacGroupsMappings)) {
		return undefined;
	}

	const fgaMappings: IFGAGroupMapping[] = [];
	Object.entries(rebacGroupsMappings!).forEach(([group, mappings]) => {
		(mappings.relations || []).forEach((mapping) => {
			fgaMappings.push({
				id: `${group}-${mapping.namespace}-${mapping.relationDefinition}-${mapping.resource}`,
				group,
				fgaType: mapping.namespace,
				relation: mapping.relationDefinition,
				resource: mapping.resource
			});
		});
	});
	return fgaMappings;
};

export const parseFGAMappings = (
	fgaMappings: IFGAGroupMapping[] | undefined
) => {
	// Only an absent list means the field was never touched. An empty one means every mapping was
	// deleted, and has to reach the server as an empty map, or the save omits the field and the
	// stored mappings stay.
	if (!fgaMappings) {
		return undefined;
	}

	const rebacGroupsMappings: Record<string, IReBACGroupMappings> = {};
	fgaMappings.forEach((mapping) => {
		if (!rebacGroupsMappings[mapping.group]?.relations) {
			rebacGroupsMappings[mapping.group] = {
				relations: []
			};
		}
		rebacGroupsMappings[mapping.group].relations.push({
			namespace: mapping.fgaType,
			relationDefinition: mapping.relation,
			resource: mapping.resource
		});
	});
	return rebacGroupsMappings;
};
